import {
    decodeStyle,
    isHidden,
    mobile,
    parseStyle,
    tablet,
} from "../../../../juntion";
// import QPDFViewNew from "./pdfviewer/QPDFViewNew";
import QPDFEmbeded from "./pdfviewer/QPDFEmbeded";

function PDFViewer({ id, db, device, gs }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;
    input = { ...input, ...(tablet(device) && ps.itablet) };
    input = { ...input, ...(mobile(device) && ps.imobile) };

    //=========================
    const fixStyle = decodeStyle(ps.fixStyle, gs);

    const style = decodeStyle(ps.style, gs);
    const styleTab = tablet(device) ? decodeStyle(ps.tablet, gs) : {};
    const styleMob = mobile(device) ? decodeStyle(ps.mobile, gs) : {};

    if (isHidden(ps.classes, device)) {
        return null;
    }

    const all_style = {
        // border: "1px solid #aaa",
        ...fixStyle,
        ...style,
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* <QPDFViewer /> */}
            <QPDFEmbeded input={input} />
            {/* <QPDFViewNew input={input} pageStyle={all_style} /> */}
        </div>
    );
}

export default PDFViewer;

// https://github.com/mattboldt/typed.js
// https://www.npmjs.com/package/react-typed
